import React, { useState, useEffect, useMemo } from 'react';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { makeStyles } from '@material-ui/core/styles';

import DateFnsUtils from '@date-io/date-fns';
import { Button } from '@material-ui/core';

import MUIDataTable from 'mui-datatables';
import { AdminService, FinanceService } from '../../utils/web_config_2';
import axios from 'axios';

/**
 * This is the POS Agent Report
 * level 1: http://197.243.20.77:8080/admin-service/api/v1/cooperative-members
 *
 * level 2-1: http://197.243.20.77:8080/admin-service/api/v1/user/pos-agents/{cooperative_member_id}
 * level 2-2: http://197.243.20.77/nxfinance/api/v1/getAgentProfile/30058
 *            http://197.243.20.77/nxfinance/api/v1/getAgentBalance/30058
 *            http://197.243.20.77/nxfinance/api/v1/getAgentTransactions/30058
 *
 */

const useStyles = makeStyles((theme) => ({
	root: {
		flexShrink: 0,
		flexFlow: 1,
		[theme.breakpoints.up('sm')]: {
			marginLeft: 250,
		},
	},
	goBackBtn: { marginBottom: 30, marginTop: 30 },
}));

function PosAgentLevel1({ goTo, members }) {
	return (
		<div>
			<MUIDataTable
				title={<h1>Cooperative Members</h1>}
				data={members}
				columns={[
					{
						name: 'Full names',
						options: {
							customBodyRender: (value, meta) => (
								<span
									style={{
										textDecoration: 'underline',
										cursor: 'pointer',
										color: 'dodgerblue',
									}}
									href='#'
									onClick={goTo(21, meta.rowData)}
								>
									{value}
								</span>
							),
						},
					},
					{
						name: 'Phone number',
					},
					{
						name: 'POS Agents',
					},
					{
						name: 'Username',
					},
					{
						name: 'Account Balance',
						options: {
							customBodyRender: (value, meta) => (
								<span
									style={{
										textDecoration: 'underline',
										cursor: 'pointer',
										color: 'dodgerblue',
									}}
									href='#'
									onClick={goTo(22, meta.rowData)}
								>
									{value}
								</span>
							),
						},
					},
					{
						name: 'Status',
					},
					{
						name: 'Creation Date',
					},
					// {
					// 	name: 'Plate Number',
					// 	options: {
					// 		customBodyRender: (value, tableMeta, updateValue) => (
					// 			<Link onClick={() => {}}>{value}</Link>
					// 		),
					// 	},
					// },
				]}
				options={{
					filterType: 'checkbox',
				}}
			/>
		</div>
	);
}

function PosAgentLevel21({ agents }) {
  console.log(agents)
	const formattedData = useMemo(() => {
		const formatted = [];
		for (let item of agents) {
			formatted.push([
				item.user_first_name + ' ' + item.user_last_name,
				item.user_phone,
				item.user_name,
				item.user_status,
				item.created_date,
			]);
		}

		return formatted;
	}, [agents]);

	return (
		<div>
			<MUIDataTable
				title={<h1>Level Two (POS Agents)</h1>}
				data={formattedData}
				columns={[
					'Full names',
					'Phone number',
					'username',
					'status',
					'Created At',
				]}
			/>
		</div>
	);
}

function PosAgentLevel22({ transactions }) {
	const formattedData = useMemo(() => {
		const formatted = [];
		for (let item of transactions) {
			formatted.push([
				item.tx_type_name,
				item.id,
				item.amount,
				item.debited_account_balance,
				item.created_at,
			]);
		}

		return formatted;
	}, [transactions]);

	return (
		<MUIDataTable
			title={<h1>Transactions</h1>}
			data={formattedData}
			columns={[
				'Transaction Type',
				'Transaction Id',
				'Transaction Amount',
				'Debited Account Balance',
				'Created At',
			]}
		/>
	);
}

export default function PosAgentReport() {
	const styles = useStyles();

	const [step, setStep] = useState({
		level: 1,
		data: null,
	});

	const [authUser, setAuthUser] = useState();
	const [members, setMembers] = useState([]);
  const [currentMap, setCurrentMap] = useState(0)

	const [userMapping, setUserMapping] = useState();

	const goTo = (level, data = null) => async () => {

			const adminInstance = axios.create(new AdminService().setHeaders(authUser.token));
			const financeInstance = axios.create(
				new FinanceService().setHeaders(JSON.parse(localStorage.getItem('nx_ag')).token)
			);

			let userMap =
				level == 21 || level == 22
					? userMapping.find((map) => map.username == data[3])
					: null;

      setCurrentMap(userMap)

			if (level == 22) {
				try {
					if (userMap.transactions == null && userMap.agent_code != null) {
						let {
							data: { data },
						} = await financeInstance.get(
							process.env.REACT_APP_FINANCE_URL +
								'/api/v1/getAgentTransactions/' +
								userMap.agent_code
						);

						console.log(data);

						setUserMapping((oldMappings) => {
							return oldMappings.map((mapping) => {
								if (mapping.username == userMap.username) {
									return {
										...userMap,
										transactions: data,
									};
								} else return mapping;
							});
						});
						setCurrentMap({
							...userMap,
							transactions: data,
						});
					}
				} catch (error) {
					console.log(error);
				}
			} else if (level == 21) {
        try {
					if (userMap.pos_agents == null) {
						let {
							data: { data },
						} = await adminInstance.get(
							process.env.REACT_APP_ADMIN_URL +
								'/api/v1/user/pos-agents/' +
								userMap.cooperative_member_id
						);

            console.log(data)

						setUserMapping((oldMappings) => {
							return oldMappings.map((mapping) => {
								if (mapping.username == userMap.username) {
									return {
										...userMap,
										pos_agents: data,
									};
								} else return mapping;
							});
						});
            setCurrentMap({
							...userMap,
							pos_agents: data,
						});
					}
				} catch (error) {
					console.log(error);
				}
			}
			setStep({ level, data });
		};

	const fetchMembers = async (token) => {
		try {
			const adminInstance = axios.create(new AdminService().setHeaders(token));
      let organization_id = JSON.parse(localStorage.getItem("nx_op")).organization.organization_id
			let {
				data: { data },
			} = await adminInstance.get(
				// TODO: Put a specific Organization Id
				process.env.REACT_APP_ADMIN_URL +
					'/api/v1/cooperative-members/organization/'+ organization_id
			);

      setMembers(data)
		} catch (error) {
		}
	};

	useEffect(() => {
		let op = localStorage.getItem('nx_op');
		if (!op) return;

		let user = JSON.parse(op);

		setAuthUser(user);
		fetchMembers(user.token);
	}, []);

	const formattedMembers = useMemo(() => {
		let formatted = [];
		let userMapppingRaw = [];

		for (let item of members) {
			formatted.push([
				item.user.user_first_name + ' ' + item.user.user_last_name,
				item.user.user_phone,
				'Loading ...',
				item.user.user_name,
				'Loading ...',
				item.user.user_status,
				item.user.created_date,
			]);
			userMapppingRaw.push({
				cooperative_member_id: item.cooperative_member_id,
				user_id: item.user.user_id,
				agent_code: item.user.agent_code,
				username: item.user.user_name,
				pos_agents: null,
				transactions: null,
			});
		}

		setUserMapping(userMapppingRaw);
		return formatted;
	}, [members]);

	return (
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
			<div className={styles.root}>
				<h1>POS Agent Report</h1>
				{step.level != 1 && (
					<div className={styles.goBackBtn}>
						<Button variant='contained' color='primary' onClick={goTo(1)}>
							Go Back
						</Button>
					</div>
				)}
				<div>
					{step.level == 1 && (
						<PosAgentLevel1 goTo={goTo} members={formattedMembers} />
					)}
					{step.level == 21 && <PosAgentLevel21 agents={currentMap.pos_agents || []} />}
					{step.level == 22 && <PosAgentLevel22 transactions={currentMap.transactions || []} />}
				</div>
			</div>
		</MuiPickersUtilsProvider>
	);
}
